import SimpleBar from 'simplebar';

const params = {};

export function initTabsScrollsar() {
    const tabsNavs = $('.nav-tabs-wr:not(.js-tabs-nav-slider)');

    if (!tabsNavs.length) {
        return;
    }

    tabsNavs.each((i, el) => new SimpleBar(el, params));
}
